const copy = {
  es: {
    nav: {
      product: 'Producto',
      features: 'Funciones',
      login: 'Iniciar sesión',
    },
    hero: {
      brand: 'DigiSpace Prime',
      headline: 'Opera tu negocio con claridad fiscal',
      sub: 'Emite CFDI 4.0 desde cualquier lugar, cumple con el SAT y concentra clientes, productos y comunicación en una sola plataforma sencilla.',
      cta: 'Probar 30 días gratis',
      note: 'Sin instalación. Cancela cuando quieras.',
    },
    product: {
      title: 'Captura en minutos, reduce tiempo y costos',
      lead: 'Facturación sin tope de folios ni cargos extras por cada comprobante.',
      items: [
        {
          title: 'CFDI ilimitados',
          text: 'Genera, emite y timbra facturas 4.0 cuantas necesites. El flujo es directo: capturas, revisas y listo.',
          cta: 'Nueva factura',
        },
        {
          title: 'Directorio de clientes',
          text: 'Guarda RFC, razón social y datos de contacto para repetir facturas sin volver a capturar todo.',
          cta: 'Ver clientes',
        },
        {
          title: 'Catálogo de bienes y servicios',
          text: 'Organiza claves, precios y descripciones para agilizar cada emisión y evitar errores de captura.',
          cta: 'Ver productos',
        },
      ],
    },
    modules: {
      title: 'Una suite que se ajusta a tu operación',
      lead: 'Herramientas conectadas para que tu equipo facture, organice y dé seguimiento sin saltar entre sistemas.',
      items: [
        {
          title: 'Facturas 4.0',
          text: 'Comprobantes fiscales digitales listos para timbrar ante el SAT, con XML y PDF disponibles al instante.',
        },
        {
          title: 'CRM de negocio',
          text: 'Centraliza clientes actuales y prospectos: historial, notas y datos útiles para tu siguiente venta.',
        },
        {
          title: 'Calendario operativo',
          text: 'Agenda vencimientos, cobros y tareas semanales para mantener el ritmo sin perder pendientes.',
        },
        {
          title: 'Mensajes SMS',
          text: 'Avisa cobros, confirma citas o envía campañas cortas con comunicación directa al celular.',
        },
      ],
    },
    steps: {
      title: 'Factura desde la palma de tu mano',
      lead: 'Somos tu aliado digital: las apps que impulsan el crecimiento de tu empresa en un solo lugar. Nada que instalar; entras con tu navegador.',
      items: [
        {
          title: 'Regístrate',
          text: 'Abre tu cuenta verificada en minutos con tu número celular.',
        },
        {
          title: 'Carga tu CSD',
          text: 'Captura datos fiscales y sube los archivos .CER y .KEY de tu sello digital.',
        },
        {
          title: 'Empieza a facturar',
          text: 'Alta de clientes y productos, luego genera y timbra CFDI 4.0 sin límite de folios.',
        },
      ],
      cta: 'Inicia hoy 30 días sin costo',
    },
    cta: {
      title: 'Lleva tu operación al siguiente nivel',
      sub: 'Activa 30 días de prueba sin costo. Cancela cuando quieras, sin letra chica confusa.',
      button: 'Crear mi cuenta',
    },
    footer: {
      about:
        'DigiSpace Prime es una plataforma integral para la operación empresarial. Cumple obligaciones fiscales con software claro, ágil y accesible desde cualquier dispositivo.',
      company: 'Empresa',
      aboutUs: 'Acerca de nosotros',
      support: 'Soporte',
      transparency: 'Transparencia',
      terms: 'Términos de servicio',
      privacy: 'Políticas de privacidad',
      notice: 'Aviso de privacidad',
      disclaimer: 'Responsabilidad',
      contact: 'Atención a clientes',
      hours: 'De lunes a viernes de 9:00 a 17:00 h.',
      phone: '(55) 4742 6486',
      email: 'soporte@digispaceprime.com',
    },
  },
  en: {
    nav: {
      product: 'Product',
      features: 'Features',
      login: 'Sign in',
    },
    hero: {
      brand: 'DigiSpace Prime',
      headline: 'Run your business with fiscal clarity',
      sub: 'Issue CFDI 4.0 from anywhere, stay aligned with SAT requirements, and keep clients, products, and outreach in one straightforward platform.',
      cta: 'Start 30 days free',
      note: 'No install needed. Cancel anytime.',
    },
    product: {
      title: 'Capture in minutes, cut time and cost',
      lead: 'Unlimited invoicing—no per-folio fees stacked onto every stamp.',
      items: [
        {
          title: 'Unlimited CFDI',
          text: 'Create, issue, and stamp 4.0 invoices as often as you need. Capture, review, done.',
          cta: 'New invoice',
        },
        {
          title: 'Client directory',
          text: 'Store RFC, legal name, and contact details so repeat invoices skip the retyping.',
          cta: 'View clients',
        },
        {
          title: 'Goods & services catalog',
          text: 'Keep keys, prices, and descriptions organized to speed issuance and reduce typos.',
          cta: 'View products',
        },
      ],
    },
    modules: {
      title: 'A suite that fits how you work',
      lead: 'Connected tools so your team can invoice, organize, and follow up without hopping between systems.',
      items: [
        {
          title: 'Invoices 4.0',
          text: 'Digital tax receipts ready to stamp with the SAT, with XML and PDF available right away.',
        },
        {
          title: 'Business CRM',
          text: 'Keep current clients and prospects in one place—history, notes, and context for the next sale.',
        },
        {
          title: 'Ops calendar',
          text: 'Track due dates, collections, and weekly tasks so nothing slips through the cracks.',
        },
        {
          title: 'SMS messaging',
          text: 'Send payment reminders, confirm appointments, or short campaigns straight to the phone.',
        },
      ],
    },
    steps: {
      title: 'Invoicing in the palm of your hand',
      lead: 'Your digital ally: the apps that push growth forward in one place. Nothing to install—open it in the browser.',
      items: [
        {
          title: 'Sign up',
          text: 'Create a verified account in minutes with your mobile number.',
        },
        {
          title: 'Upload your CSD',
          text: 'Enter tax details and upload the .CER and .KEY files for your digital seal.',
        },
        {
          title: 'Start invoicing',
          text: 'Add clients and products, then generate and stamp unlimited CFDI 4.0.',
        },
      ],
      cta: 'Start 30 days free today',
    },
    cta: {
      title: 'Take your operation to the next level',
      sub: 'Activate a 30-day free trial. Cancel whenever you want—no confusing fine print.',
      button: 'Create my account',
    },
    footer: {
      about:
        'DigiSpace Prime is an all-in-one platform for running a business. Meet tax obligations with clear software you can open from any device.',
      company: 'Company',
      aboutUs: 'About us',
      support: 'Support',
      transparency: 'Transparency',
      terms: 'Terms of service',
      privacy: 'Privacy policy',
      notice: 'Privacy notice',
      disclaimer: 'Disclaimer',
      contact: 'Customer care',
      hours: 'Monday to Friday, 9:00 a.m. to 5:00 p.m.',
      phone: '(55) 4742 6486',
      email: 'soporte@digispaceprime.com',
    },
  },
};

export function t(lang) {
  return copy[lang] || copy.es;
}

export default copy;
